import React from 'react';
import { Box, Stack } from '@mui/material';
import { ExerciseMeta, exerciseById } from 'pages/Learning/learningMeta';
import LearningModeIcon from 'pages/Learning/components/LearningModeIcon';

interface LearningExerciseChipsProps {
  ids: Array<ExerciseMeta['id']>;
}

const LearningExerciseChips: React.FC<LearningExerciseChipsProps> = ({
  ids,
}) => {
  return (
    <Stack direction={'row'} sx={{ flexWrap: 'wrap', gap: 0.75 }}>
      {ids.map((id) => {
        const e = exerciseById(id);
        if (!e) return null;
        return (
          <Box
            key={id}
            sx={{
              alignItems: 'center',
              bgcolor: 'background.default',
              border: '1px solid',
              borderColor: 'primary.tableBorder',
              borderRadius: 999,
              color: 'text.secondary',
              display: 'inline-flex',
              fontSize: 12,
              fontWeight: 600,
              gap: 0.6,
              px: 1.1,
              py: 0.5,
              '& > .lp-icon': { color: 'primary.main' },
            }}
          >
            <Box component={'span'} className={'lp-icon'} sx={{ display: 'inline-flex' }}>
              <LearningModeIcon name={e.icon} size={15} />
            </Box>
            {e.label}
          </Box>
        );
      })}
    </Stack>
  );
};

export default LearningExerciseChips;
